<template>
  <div class="sidebar">
    <ul class="nav nav-sidebar">
      <template v-for="{ label, linkName, iconClass, children, adminOnly } in options">
        <template v-if="children && children.length">
          <collapsible-menu
            :key="label"
            :label="label"
            :iconClass="iconClass"
            :children="children"
            :is-admin="isAdmin"
          />
        </template>
        <template v-else-if="isAdmin || !adminOnly">
          <router-link :key="label" tag="li" :to="{ name: linkName }">
            <a href="#">
              <span :class="[iconClass, 'sidebar-icon']"></span>
              <span>{{ label }}</span>
            </a>
          </router-link>
        </template>
      </template>
    </ul>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import CollapsibleMenu from './CollapsibleMenu.vue';
  export default {
    name: 'Sidebar',

    components: {
      CollapsibleMenu,
    },

    data() {
      return {
        options: [
          {
            label: 'Skills',
            linkName: 'skills',
            iconClass: 'fas fa-list-ul mr-5',
          },
          {
            label: 'Scenario',
            linkName: 'scenario',
            iconClass: 'fas fa-route mr-5',
          },
          {
            label: 'Characters',
            linkName: 'characters',
            iconClass: 'fas fa-address-book mr-5',
          },
          {
            label: 'Drive',
            linkName: 'drive',
            iconClass: 'fas fa-folder mr-5',
          },
          {
            label: 'Gadgets',
            linkName: 'gadgets',
            iconClass: 'fas fa-puzzle-piece mr-5',
          },
          {
            label: 'Inbox',
            linkName: 'inbox',
            iconClass: 'fas fa-mail-bulk mr-5',
          },
          {
            label: 'Report',
            iconClass: 'fas fa-file-alt mr-5',
            children: [
              {
                label: 'Scoring Report',
                linkName: 'scoring',
              },
              {
                label: 'Outline Report',
                linkName: 'outline',
              },
            ],
          },

          {
            label: 'Administration',
            linkName: 'administration',
            iconClass: 'fas fa-cog mr-5',
          },
        ],
      };
    },

    computed: {
      ...mapState('user', ['isAdmin']),
      ...mapState('editMode', {
        isSaving: 'hasUnsavedEdits',
      }),
    },
  };
</script>
<style lang="scss" scoped>
  /* Hide for mobile, show later */
  .sidebar {
    display: none;
  }

  @media (min-width: 768px) {
    .sidebar {
      z-index: 998;
      display: block;
      position: static;
      padding: 0 20px 20px;
      overflow-x: hidden;
      overflow-y: auto;
      /* Scrollable contents if viewport is shorter than content. */
      background-color: #627385;
    }
  }

  @media print {
    .sidebar {
      display: none;
    }
  }

  .collapsed {
    .nav-sidebar > li > a {
      text-align: center;
      span:nth-of-type(2) {
        display: none;
      }
    }
  }

  /* Sidebar navigation */

  .nav-sidebar {
    margin-right: -21px;
    margin-left: -20px;

    &::v-deep {
      .sidebar-icon {
        width: 16px;
      }
    }
  }

  .nav-sidebar::v-deep li:not(.nav-child) > a {
    font-size: 14px;
    color: white;
    padding: 20px;
    border-bottom: 1px solid #004054;

    * {
      vertical-align: middle;
    }

    &:hover,
    &:focus {
      color: #fff;
      background-color: #3b576a !important;
    }
  }

  .nav-sidebar::v-deep li.active:not(.nav-child) > a,
  .nav-sidebar::v-deep li.active:not(.nav-child) > a:focus,
  .nav-sidebar::v-deep li.active:not(.nav-child) > a:hover {
    font-weight: bold;
    color: #fff;
    background-color: #004054 !important;
  }
</style>
